import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=cb2df3ce&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb2df3ce')) {
      api.createRecord('cb2df3ce', component.options)
    } else {
      api.reload('cb2df3ce', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=cb2df3ce&", function () {
      api.rerender('cb2df3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o6g5fINOb4IB/JS/pricehelp.vue"
export default component.exports